import { resolve } from "inversify-react";
import * as React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import AdminTable from "src/core/ui/admin-table";
import Icon from "src/core/ui/icon";
import AdminService from "src/services/admin.service";

interface UserInformation {
    id: any;
    email: string;
    name: string;
    last_name: string;
    full_name: string;
    country: string;
    // user_role: UserType;
    citizenship: string;
    phone: string;
    date_of_birth: string;
    company_and_news_updates: boolean;
    emergency_notifications: boolean;
    notifications_of_transfer: boolean;
    favorite_notifications: boolean;
    emailVerified: boolean;
    is_verified?: boolean;
    blocked?: boolean;
    type: UserType;
    prove_of_address?: string;
    prove_of_identity?: string;
    wallet_address: string;
    address: string;
    city: string;
    postCode: string;
    credits?: number;
    blockchainAccountId?: number;
    dni?: string;
}

enum UserType {
    ARTIST = "artist",
    COLLECTOR = "collector",
    ADMIN = "admin",
}
interface IUsersTableProps {
    users: UserInformation[];
}

interface IUsersTableState {}

class UsersTable extends React.Component<IUsersTableProps, IUsersTableState> {
    @resolve(AdminService)
    public adminService: AdminService;

    public columns: any[] = [
        {
            label: "VERIFIED",
            flex: 1,
        },
        {
            label: "EMAIL VERIFIED",
            flex: 1,
        },
        {
            label: "ID",
            flex: 2,
        },
        {
            label: "NAME",
            flex: 2,
        },
        {
            label: "EMAIL",
            flex: 3,
        },
        {
            label: "TYPE",
            flex: 1,
        },
        {
            label: "ACTIONS",
            flex: 3,
        },
    ];

    public verifyUser(id: number): void {
        this.adminService.verifyUser(id);
    }

    public blockUser(id: number): void {
        this.adminService.blockUser(id);
    }

    public unblockUser(id: number): void {
        this.adminService.unblockUser(id);
    }

    public deleteUser(u: UserInformation): void {
        confirmAlert({
            title: "Confirm to delete",
            message: "Are you sure to do delete user " + u.name + "?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.adminService.deleteUser(u.id),
                },
                {
                    label: "No",
                    onClick: () => close(),
                },
            ],
        });
    }

    public render(): JSX.Element {
        const { users } = this.props;

        const userRows: JSX.Element[][] = users.map((u) => [
            <div className="check-box">
                {u.is_verified !== undefined && u.is_verified && <Icon type="check" />}
                {u.is_verified !== undefined! && !u.is_verified && <Icon type="close" />}
                <span className="checkmark"></span>
            </div>,
            <div className="check-box">
                {u.emailVerified && <Icon type="check" />}
                <span className="checkmark"></span>
            </div>,
            <div>{u.id}</div>,
            <div>{u.name}</div>,
            <div style={{ textAlign: "left" }}>{u.email}</div>,
            <div>{u.type === UserType.ARTIST ? "Artist" : u.type === UserType.COLLECTOR ? "Collector" : "Admin"}</div>,
            <div className="admin-options">
                {(u.is_verified === undefined || !u.is_verified) && (
                    <a className="positive" onClick={() => this.verifyUser(u.id)}>
                        Verify
                    </a>
                )}
                {u.blocked ? (
                    <a className="positive" onClick={() => this.unblockUser(u.id)}>
                        Unblock
                    </a>
                ) : (
                    <a className="negative" onClick={() => this.blockUser(u.id)}>
                        Block
                    </a>
                )}
                <a className="negative" onClick={() => this.deleteUser(u)}>
                    Delete
                </a>
            </div>,
        ]);

        return <AdminTable columns={this.columns} rows={userRows} />;
    }
}

export default UsersTable;



// WEBPACK FOOTER //
// ./src/components/admin_panel/tables/users-table.tsx